import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const MobileHeader = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div>
      <div className="flex fixed bottom-2 left-1 right-1 md:hidden border border-perpx-cyan/20 py-[6px] rounded-3xl mx-auto w-[94%] bg-perpx-dark-tertiary/80 backdrop-blur-md gap-6 justify-evenly items-center">
        <p
          onClick={() => navigate("/")}
          className={`w-fit h-fit rounded-[48px] px-[20px] py-[6px] font-medium text-[16px] cursor-pointer border transition-all ${
            pathname === "/"
              ? "bg-perpx-cyan/20 text-perpx-cyan border-perpx-cyan/30 shadow-perpx-glow"
              : "bg-transparent border-transparent text-perpx-text-secondary"
          }`}
        >
          Swap
        </p>
        <p
          onClick={() => navigate("/pool")}
          className={`w-fit h-fit rounded-[48px] px-[20px] py-[6px] font-medium text-[16px] cursor-pointer border transition-all ${
            pathname === "/pool"
              ? "bg-perpx-cyan/20 text-perpx-cyan border-perpx-cyan/30 shadow-perpx-glow"
              : "bg-transparent border-transparent text-perpx-text-secondary"
          }`}
        >
          Pool
        </p>
      </div>
    </div>
  );
};

export default MobileHeader;
